import { isGroupOnly, isIndividual } from '_legacy/utils/Visibility';
import Logger from '../../../diagnostics/logging/logger';
import MixpanelLogger from '../../../diagnostics/logging/mixpanelLogger';
import { cloneDeep } from 'lodash';

export const createConvertToFixtureMenuItem = (props, node, gridId) => {
    const { group, data } = node;
    const { id, visibility, privacy, datasetId, groupOnlyType } = data;
    const { selectedGroup } = props;
    const groupOnly = isGroupOnly(visibility);
    const title = 'Convert to Fixture';

    return {
        name: title,
        action: () => {
            if (!group && data) {
                Logger.trackEvent('grid.context.convertToFixture', gridId);
                MixpanelLogger.trackNewFixtureEvent(
                    id,
                    groupOnly,
                    privacy,
                    isIndividual(visibility),
                    selectedGroup.name,
                    'Converted from Order',
                    datasetId,
                    groupOnlyType
                );

                const clonedData = cloneDeep(data);
                props.onConvertToFixture(clonedData);
            }
        },
        tooltip: title,
    };
};
